import { ADividerOrientation } from '../../atoms/ADivider/index';
import { MButton } from '../MButton/index';
import { MButtonType, MButtonSize, MButtonIconPlacement } from '../MButton/MButton.types';
import { MBreadcrumb } from '../MBreadcrumb/index';
import { MBreadcrumbGroupProps } from './MBreadcrumbGroup.types';
import * as Styled from './MBreadcrumbGroup.styles';

const DEFAULT_BACK_BUTTON_TEXT = 'Back';

const TEST_ID = 'web-ui-kit-MBreadcrumbGroup';
const COMPONENT_NAME = 'm-web-ui-kit-MBreadcrumbGroup';

function MBreadcrumbGroup({ backButton, mButton, mBreadcrumbMulti }: MBreadcrumbGroupProps) {
  const _mButtonProps = {
    ...mButton,
    variant: MButtonType.Tertiary,
    size: MButtonSize.M,
    iconPlacement: MButtonIconPlacement.Leading,
    iconClass: 'icon-back-arrow',
    buttonText: mButton?.buttonText || DEFAULT_BACK_BUTTON_TEXT,
  };
  const hasItems = Boolean(mBreadcrumbMulti?.length);
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID}>
      {backButton && (
        <Styled.BackButtonWrapper>
          <MButton {..._mButtonProps} />
          {hasItems && <Styled.ADivider orientation={ADividerOrientation.Vertical} />}
        </Styled.BackButtonWrapper>
      )}
      {hasItems && mBreadcrumbMulti.map((item, idx) => <MBreadcrumb key={idx} {...item} />)}
    </Styled.Wrapper>
  );
}

export { MBreadcrumbGroup, TEST_ID as M_BREADCRUMB_GROUP_TEST_ID };
